/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Mateus Furrier",
  title: "Olá",
  titleEn: "Hi",
  subTitle: (
    "Sou Mateus Furrier. IT Manager com mais de 18 anos de experiência em liderança técnica, desenvolvimento de sistemas e integração de soluções empresariais. Especialista em SAP Business One, Cibersegurança e Desenvolvimento Full Stack, com atuação estratégica na adoção de inovações para impulsionar a performance do negócio."
  ),
  subTitleEn: (
    "I'm Mateus Furrier. IT Manager with over 18 years of experience in technical leadership, system development, and enterprise solution integration. Specialist in SAP Business One, Cybersecurity, and Full Stack Development, with strategic focus on adopting innovations to drive business performance."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1wwvteaaEP7LdShTgriLIe6Qur6vD3C4s/view?usp=sharing",
  displayGreeting: true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/matfurrier",
  linkedin: "https://www.linkedin.com/in/mateusfurrier/?locale=pt_BR",
  gmail: "matfurrier@gmail.com",
  gitlab: "https://gitlab.com/matfurrier",
  website: "https://www.furrierlabs.com.br",
  whatsapp: "https://wa.me/5543999242485",
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "Tech Stack",
  skills: [
    emoji("🧩 Desenvolvimento back-end com Node.js e Python"),
    emoji("🌐 Integrações com SAP B1 e sistemas legados via APIs REST/SOAP"),
    emoji("⚙️ Liderança técnica em TI e Gestão de Infraestrutura"),
    emoji("☁️ Cloud & DevOps com Docker, Kubernetes, Portainer e CI/CD"),
    emoji("🔒 Cibersegurança com Wazuh, GoPhish, MFA e conformidade LGPD"),
    emoji("📊 BI com Qlik Sense, QlikView e processos ETL"),
    emoji("💡 Arquitetura de software com foco em soluções escaláveis")
  ],
  skillsEn: [
    emoji("🧩 Back-end development with Node.js and Python"),
    emoji("🌐 SAP B1 and legacy systems integration via REST/SOAP APIs"),
    emoji("⚙️ Technical leadership and infrastructure management"),
    emoji("☁️ Cloud & DevOps with Docker, Kubernetes, Portainer and CI/CD"),
    emoji("🔒 Cybersecurity with Wazuh, GoPhish, MFA and LGPD compliance"),
    emoji("📊 BI with Qlik Sense, QlikView and ETL processes"),
    emoji("💡 Software architecture focused on scalable solutions")
  ],
  
  softwareSkills: [
    { skillName: "Node.js", fontAwesomeClassname: "fab fa-node" },
    { skillName: "Python", fontAwesomeClassname: "fab fa-python" },
    { skillName: "TypeScript", fontAwesomeClassname: "fas fa-code" },
    { skillName: "JavaScript", fontAwesomeClassname: "fab fa-js" },
    { skillName: "React", fontAwesomeClassname: "fab fa-react" },
    { skillName: "SAP Business One", fontAwesomeClassname: "fa-solid fa-briefcase" },
    { skillName: "PostgreSQL", fontAwesomeClassname: "fas fa-database" },
    { skillName: "MySQL", fontAwesomeClassname: "fas fa-database" },
    { skillName: "ETL", fontAwesomeClassname: "fas fa-database" },
    { skillName: "Qlik Sense / QlikView", fontAwesomeClassname: "fas fa-chart-pie" },
    { skillName: "REST APIs", fontAwesomeClassname: "fas fa-cloud" },
    { skillName: "Docker", fontAwesomeClassname: "fab fa-docker" },
    { skillName: "Git", fontAwesomeClassname: "fab fa-git" },
    { skillName: "Cryptography", fontAwesomeClassname: "fas fa-lock" },
    { skillName: "Cybersecurity", fontAwesomeClassname: "fas fa-shield-alt" }
  ],
  
  display: true
};


const educationInfo = {
  display: true,
  schools: [
    {
      schoolName: "MBA Em Cyber Security - Governance & Management",
      schoolNameEn: "MBA in Cyber Security - Governance & Management",
      logo: require("./assets/images/fiapLogo.png"),
      subHeader: "2023-2024 | FIAP",
      subHeaderEn: "2023-2024 | FIAP",
      desc: "",
      descEn: "",
      descBullets: [],
      descBulletsEn: []
    },
    {
      schoolName: "Academia SAP Business One",
      schoolNameEn: "SAP Business One Academy",
      logo: require("./assets/images/uppertoolsLogo.png"),
      subHeader: "2022 | Uppertools",
      subHeaderEn: "2022 | Uppertools",
      desc: "",
      descEn: "",
      descBullets: [],
      descBulletsEn: []
    },
    {
      schoolName: "Licenciatura Em Matemática",
      schoolNameEn: "Mathematics Degree",
      logo: require("./assets/images/cruzeiroLogo.png"),
      subHeader: "2016-2017 | Universidade Cruzeiro Do Sul",
      subHeaderEn: "2016-2017 | Cruzeiro do Sul University",
      desc: "",
      descEn: "",
      descBullets: [],
      descBulletsEn: []
    },
    {
      schoolName: "Pós-Graduação Em Engenharia De Software",
      schoolNameEn: "Software Engineering Post-Graduation",
      logo: require("./assets/images/unifilLogo.png"),
      subHeader: "2011-2012 | UNIFIL - Centro Universitário Filadélfia",
      subHeaderEn: "2011-2012 | UNIFIL - Filadélfia University Center",
      desc: "",
      descEn: "",
      descBullets: [],
      descBulletsEn: []
    },
    {
      schoolName: "Engenharia Da Computação",
      schoolNameEn: "Computer Engineering",
      logo: require("./assets/images/unoparLogo.png"),
      subHeader: "2001-2005 | UNOPAR - Universidade Norte Do Paraná",
      subHeaderEn: "2001-2005 | UNOPAR - North Paraná University",
      desc: "",
      descEn: "",
      descBullets: [],
      descBulletsEn: []
    }
  ]
};


const techStack = {
  viewSkillBars: true,
  experience: [
    { Stack: "SAP Business One", progressPercentage: "95%" },
    { Stack: "Cybersecurity (Wazuh, LGPD)", progressPercentage: "90%" },
    { Stack: "QlikView / Qlik Sense", progressPercentage: "90%" },
    { Stack: "ETL & Data Integration", progressPercentage: "95%" },
    { Stack: "Node.js / React / Python", progressPercentage: "90%" },
    { Stack: "Docker / Kubernetes / CI-CD", progressPercentage: "85%" }
  ],
  displayCodersrank: false
};

// Some big projects you have worked on

const bigProjects = {
  title: "Projetos",
  titleEn: "Projects",
  subtitle: "Alguns Projetos Desenvolvidos Por Mim",
  subtitleEn: "Some Projects Developed By Me",
  projects: [
    {
      image: require("./assets/images/clinicsaas1.png"),
      projectName: "ClinicManager",
      projectDesc: "Sistema completo para clínicas, com agendamento, prontuário eletrônico, gestão financeira, prescrições e portal do paciente.",
      projectDescEn: "Complete clinic system with scheduling, electronic medical records, financial management, prescriptions, and patient portal.",
      footerLink: [{ name: "Veja Mais", nameEn: "See More", url: "https://www.furrierlabs.com.br/clinicsaas" }]
    },
    {
      image: require("./assets/images/ssomanager.png"),
      projectName: "SSO Manager",
      projectDesc: "Gestão de colaboradores terceirizados e documentos de segurança, com dashboards, auditorias e controle de permissões.",
      projectDescEn: "Management of third-party employees and safety documents, with dashboards, audits, and access control.",
      footerLink: [{ name: "Veja Mais", nameEn: "See More", url: "https://www.furrierlabs.com.br/ssomanager" }]
    },
    {
      image: require("./assets/images/busspass1.png"),
      projectName: "Busspass",
      projectDesc: "Sistema de agendamento e controle de embarque para excursões e transporte escolar, com gestão via painel administrativo.",
      projectDescEn: "Booking and boarding control system for tours and school transport, managed through an admin panel.",
      footerLink: [{ name: "Veja Mais", nameEn: "See More", url: "https://www.furrierlabs.com.br/busspass" }]
    },
    {
      image: require("./assets/images/radar3601.png"),
      projectName: "Radar360",
      projectDesc: "Painel modular para indicadores escolares, com navegação por áreas como rondas, alimentação e frequência.",
      projectDescEn: "Modular dashboard for school indicators, with navigation by areas such as rounds, meals, and attendance.",
      footerLink: [{ name: "Veja Mais", nameEn: "See More", url: "https://www.furrierlabs.com.br/radar360" }]
    },
    {
      image: require("./assets/images/dresap.png"),
      projectName: "Budget vs Actual",
      projectDesc: "Sistema de controle orçamentário integrado ao SAP B1 com dashboards dinâmicos e comparações em tempo real.",
      projectDescEn: "Budget control system integrated with SAP B1 with dynamic dashboards and real-time comparisons.",
      footerLink: [{ name: "Veja Mais", nameEn: "See More", url: "https://github.com/matfurrier/budget_x_realizado" }]
    },
    {
      image: require("./assets/images/mpv222.png"),
      projectName: "Mapa de Vendas APP",
      projectDesc: "Dashboard de metas e performance com extração automática de dados do SAP e visualização por vendedor e período.",
      projectDescEn: "Goals and performance dashboard with automatic SAP data extraction and visualization by salesperson and period.",
      footerLink: [{ name: "Veja Mais", nameEn: "See More", url: "https://github.com/matfurrier/mpv" }]
    },
    {
      image: require("./assets/images/sapapprovals.png"),
      projectName: "Sistema de Aprovações SAP",
      projectDesc: "Sistema web de aprovações de pedidos de venda automatizado integrado com o SAP/CRM.",
      projectDescEn: "Web system for automated sales order approvals integrated with SAP/CRM.",
      footerLink: [{ name: "Veja Mais", nameEn: "See More", url: "https://github.com/matfurrier/ApprovalCRMSAP" }]
    },
    {
      image: require("./assets/images/messageflow.png"),
      projectName: "MessageFlow Pro",
      projectDesc: "Solução web para automação e gestão de mensagens empresariais, otimizando campanhas e comunicação com clientes.",
      projectDescEn: "Web solution for automation and management of business messages, optimizing campaigns and customer communication.",
      footerLink: [{ name: "Veja Mais", nameEn: "See More", url: "https://github.com/matfurrier/MessageFlowPro" }]
    },
    {
      image: require("./assets/images/wazuhlogo.png"),
      projectName: "Wazuh - SIEM",
      projectDesc: "Implementação do Wazuh com monitoramento contínuo e proteção proativa. Parte central da estratégia de cibersegurança.",
      projectDescEn: "Wazuh implementation with continuous monitoring and proactive protection. Central part of the cybersecurity strategy.",
      footerLink: [{ name: "Veja Mais", nameEn: "See More", url: "https://github.com/matfurrier/Wazuh" }]
    }
  ],
  display: true
};



const workExperiences = {
  display: true,
  experience: [
    {
      role: "IT Manager | Tech Lead | Full Stack & SAP Expert",
      roleEn: "IT Manager | Tech Lead | Full Stack & SAP Expert",
      company: "De Sangosse",
      companylogo: require("./assets/images/desangosseLogo.png"),
      date: "Outubro, 2017 - Até O Momento",
      dateEn: "October, 2017 - Present",
      desc: "Liderança técnica no desenvolvimento de sistemas internos e integrações com SAP B1. Atuação estratégica em automações com Node.js, Python, React.js e uso de APIs REST. Implementação de containers com Docker, Kubernetes e Portainer. Responsável por iniciativas de cibersegurança com Wazuh, OAuth 2.0, GoPhish e MFA.",
      descEn: "Technical leadership in internal systems development and SAP B1 integrations. Strategic role in automations with Node.js, Python, React.js and REST APIs. Container implementation with Docker, Kubernetes and Portainer. Responsible for cybersecurity initiatives with Wazuh, OAuth 2.0, GoPhish and MFA.",
      descBullets: [],
      descBulletsEn: []
    },
    {
      role: "Analista De Sistemas / DBA",
      roleEn: "Systems Analyst / DBA",
      company: "Serilon Brasil",
      companylogo: require("./assets/images/serilonLogo.png"),
      date: "Maio, 2011 - Outubro, 2017",
      dateEn: "May, 2011 - October, 2017",
      desc: "Implantação do ERP Dynamics AX, integração de sistemas, desenvolvimento de dashboards no QlikView e Salesforce, modelagem de processos e administração do banco SQL Server. Gestão de infraestrutura e segurança da informação.",
      descEn: "Dynamics AX ERP implementation, system integration, dashboard development in QlikView and Salesforce, process modeling and SQL Server database administration. Infrastructure and information security management.",
      descBullets: [],
      descBulletsEn: []
    },
    {
      role: "Analista De Suporte",
      roleEn: "Support Analyst",
      company: "Colégio Marista De Londrina",
      companylogo: require("./assets/images/maristaLogo.png"),
      date: "Maio, 2009 - Maio, 2011",
      dateEn: "May, 2009 - May, 2011",
      desc: "Administração de parque computacional, suporte a usuários, backup, servidores, rede e telefonia. Documentação e padronização de processos.",
      descEn: "Computer park administration, user support, backup, servers, network and telephony. Documentation and process standardization.",
      descBullets: [],
      descBulletsEn: []
    },
    {
      role: "Analista De Sistemas",
      roleEn: "Systems Analyst",
      company: "Colégio Maxi De Londrina",
      companylogo: require("./assets/images/maxiLogo.png"),
      date: "Dezembro, 2005 - Dezembro, 2008",
      dateEn: "December, 2005 - December, 2008",
      desc: "Responsável pela infraestrutura de TI, suporte ao usuário e administração do ERP. Gestão de rede e telefonia com documentação técnica.",
      descEn: "Responsible for IT infrastructure, user support and ERP administration. Network and telephony management with technical documentation.",
      descBullets: [],
      descBulletsEn: []
    }
  ]
};


const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};



// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  titleEn: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",
  subtitleEn:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Google Code-In Finalist",
      titleEn: "Google Code-In Finalist",
      subtitle:
        "First Pakistani to be selected as Google Code-in Finalist from 4000 students from 77 different countries.",
      subtitleEn:
        "First Pakistani to be selected as Google Code-in Finalist from 4000 students from 77 different countries.",
      image: require("./assets/images/codeInLogo.webp"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
        {
          name: "Certification",
          nameEn: "Certification",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing"
        },
        {
          name: "Award Letter",
          nameEn: "Award Letter",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
        },
        {
          name: "Google Code-in Blog",
          nameEn: "Google Code-in Blog",
          url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
        }
      ]
    },
    {
      title: "Google Assistant Action",
      titleEn: "Google Assistant Action",
      subtitle:
        "Developed a Google Assistant Action JavaScript Guru that is available on 2 Billion devices world wide.",
      subtitleEn:
        "Developed a Google Assistant Action JavaScript Guru that is available on 2 Billion devices world wide.",
      image: require("./assets/images/googleAssistantLogo.webp"),
      imageAlt: "Google Assistant Action Logo",
      footerLink: [
        {
          name: "View Google Assistant Action",
          nameEn: "View Google Assistant Action",
          url: "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en"
        }
      ]
    },
    {
      title: "PWA Web App Developer",
      titleEn: "PWA Web App Developer",
      subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
      subtitleEn: "Completed Certifcation from SMIT for PWA Web App Development",
      image: require("./assets/images/pwaLogo.webp"),
      imageAlt: "PWA Logo",
      footerLink: [
        { name: "Certification", nameEn: "Certification", url: "" },
        {
          name: "Final Project",
          nameEn: "Final Project",
          url: "https://pakistan-olx-1.firebaseapp.com/"
        }
      ]
    }
  ],
  display: false
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  titleEn: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  subtitleEn:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      titleEn: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?",
      descriptionEn:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      titleEn: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies.",
      descriptionEn:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  titleEn: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),
  subtitleEn: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      titleEn: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      subtitleEn: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  titleEn: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",
  subtitleEn: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contato ☎️"),
  titleEn: emoji("Contact ☎️"),
  subtitle:
    "Quer discutir um projeto ou apenas dizer oi? Minha caixa de entrada está aberta para todos.",
  subtitleEn:
    "Want to discuss a project or just say hi? My inbox is open for everyone.",
  number: "+55-43-99924-2485",
  email_address: "matfurrier@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable
};
